import styled from "styled-components"

export const FlowChartContainer = styled.div`
  padding: 60px 0;
  background-image: url(${props => props.img});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  @media (max-width: 768px) {
    padding-top: 0;
  }
`
export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
  display: flex;
  align-items: center;

  .arrow-down {
    display: none;
  }

  @media (max-width: 768px) {
    flex-direction: column;

    .arrow-right {
      display: none;
    }

    .arrow-down {
      display: block;
      margin-top: 30px;
    }
  }

  .arrow {
    color: ${props => props.theme.colors.darkBlue};
    font-size: 24px;
  }
`

export const Step = styled.div`
  flex: 2;
  margin: 0 20px;
  text-align: center;

  p {
    font-weight: 600;
    color: ${props => props.theme.colors.darkBlue};
  }

  @media (max-width: 768px) {
    img {
      width: 300px;
    }
  }
`
